// import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Alert, CircularProgress } from '@mui/material';
// import VideocamIcon from '@mui/icons-material/Videocam';
// import { SET_CAMERA_SOURCE } from 'store/actions';
// // import Tooltip from '@mui/material/Tooltip';
// import { Box } from 'lucide-react';

// const EvidenceList = ({ date, device }) => {
//   const dispatch = useDispatch();
//   const [thumbnails, setThumbnails] = useState({});
//   const [videoData, setVideoData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [source, setSource] = useState('');
//   const [visibleItems, setVisibleItems] = useState(5);
//   const containerRef = useRef(null);
//   const observerRef = useRef(null);
//   const videoRefs = useRef({});
//   const thumbnailQueue = useRef([]);
//   const processingThumbnail = useRef(false);
//   const currentDate = useSelector((state) => state.customization.currentDate);
//   const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
//   const loadingRef = useRef(false);
//   const thumbnailsProcessedRef = useRef({});
//   // const [selectedVideo, setSelectedVideo] = useState(null);
// const source_id = JSON.parse(localStorage.getItem('source'));
//   // Fetch video data
//   const fetchVideoData = async (date, device) => {
//     try {
//       setLoading(true);
//       setError(null);

//       const response = await fetch('https://db.neophyte.live/sentinel-api/api/sentinel/evidenceList', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ date, source: source_id })
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const data = await response.json();
//       setVideoData(data);
//       thumbnailsProcessedRef.current = {};

//       if (data && data.length > 0 && data[0]?.videos) {
//         const videoUrl = `${data[0].videos}`;
//         setSource(videoUrl);
//         // setSelectedVideo(data[0]);
//         dispatch({ type: SET_CAMERA_SOURCE, videoSource: videoUrl });
//       }
//     } catch (error) {
//       console.error('Error fetching video data:', error);
//       setError(error.message || 'Failed to fetch evidence data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const convertLong = (value) => {
//   //   if (value && typeof value === 'object' && 'low' in value && 'high' in value) {
//   //     return value.low; // or value.toString() if you need the full value
//   //   }
//   //   return value;
//   // };

//   // Process thumbnail queue to avoid too many parallel requests
//   const processNextThumbnail = useCallback(() => {
//     if (processingThumbnail.current || thumbnailQueue.current.length === 0) return;

//     processingThumbnail.current = true;
//     const { videoPath, index } = thumbnailQueue.current.shift();

//     if (thumbnails[index] || thumbnailsProcessedRef.current[index]) {
//       processingThumbnail.current = false;
//       processNextThumbnail();
//       return;
//     }

//     thumbnailsProcessedRef.current[index] = true;

//     // Create a new video element for thumbnail generation
//     const video = document.createElement('video');
//     videoRefs.current[index] = video;

//     // Set important attributes
//     video.src = convertAzureBlobLink(videoPath);
//     video.crossOrigin = 'anonymous';
//     video.preload = 'metadata';
//     video.muted = true; // Important for autoplay in some browsers
//     video.playsInline = true; // Better mobile support

//     // Add to DOM temporarily (can help with CORS issues in some browsers)
//     video.style.display = 'none';
//     document.body.appendChild(video);

//     const cleanup = () => {
//       video.removeEventListener('loadeddata', onLoadedData);
//       video.removeEventListener('loadedmetadata', onLoadedMetadata);
//       video.removeEventListener('seeked', onSeeked);
//       video.removeEventListener('error', onError);

//       // Proper cleanup
//       video.pause();
//       video.removeAttribute('src');
//       video.load(); // Causes the browser to release resources

//       if (document.body.contains(video)) {
//         document.body.removeChild(video);
//       }

//       delete videoRefs.current[index];
//       processingThumbnail.current = false;
//       setTimeout(processNextThumbnail, 100);
//     };

//     const onLoadedData = () => {
//       // Alternative event if loadedmetadata doesn't fire
//       if (!video.seeking) {
//         video.currentTime = Math.min(2, video.duration * 0.1);
//       }
//     };

//     const onLoadedMetadata = () => {
//       // Video metadata loaded, seek to desired position
//       try {
//         if (video.duration && video.duration !== Infinity) {
//           video.currentTime = Math.min(2, video.duration * 0.1);
//         } else {
//           // If duration is not available, try to seek to a reasonable position
//           video.currentTime = 2;
//         }
//       } catch (err) {
//         console.warn('Error seeking video:', err);
//         // Try to play a bit to get frames
//         video
//           .play()
//           .then(() => {
//             setTimeout(() => {
//               video.pause();
//               captureFrame();
//             }, 500);
//           })
//           .catch(cleanup);
//       }
//     };

//     const captureFrame = () => {
//       try {
//         const canvas = document.createElement('canvas');
//         [canvas.width, canvas.height] = [240, 135];
//         const ctx = canvas.getContext('2d');

//         // Clear canvas with black background
//         ctx.fillStyle = '#000';
//         ctx.fillRect(0, 0, canvas.width, canvas.height);

//         // Draw video frame
//         if (video.videoWidth && video.videoHeight) {
//           ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
//           const thumbnailData = canvas.toDataURL('image/jpeg', 0.7);

//           // Update thumbnails state
//           setThumbnails((prev) => {
//             if (prev[index]) return prev;
//             return { ...prev, [index]: thumbnailData };
//           });
//         } else {
//           throw new Error('Video dimensions not available');
//         }
//       } catch (e) {
//         console.error(`Thumbnail error for index ${index}:`, e);

//         // Generate fallback thumbnail with type info
//         generateFallbackThumbnail(index, videoData[index]?.type || 'Video');
//       } finally {
//         cleanup();
//       }
//     };

//     const onSeeked = () => {
//       // Video has been seeked to the position
//       captureFrame();
//     };

//     const onError = (e) => {
//       console.error(`Video load error for index ${index}:`, e);

//       // Generate fallback thumbnail with type info
//       generateFallbackThumbnail(index, videoData[index]?.type || 'Video');

//       cleanup();
//     };

//     // Generate a fallback thumbnail with text
//     const generateFallbackThumbnail = (idx, videoType) => {
//       const canvas = document.createElement('canvas');
//       [canvas.width, canvas.height] = [240, 135];
//       const ctx = canvas.getContext('2d');

//       // Create gradient background
//       const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
//       gradient.addColorStop(0, '#2c3e50');
//       gradient.addColorStop(1, '#34495e');
//       ctx.fillStyle = gradient;
//       ctx.fillRect(0, 0, canvas.width, canvas.height);

//       // Add text
//       ctx.font = 'bold 16px Arial';
//       ctx.fillStyle = '#fff';
//       ctx.textAlign = 'center';
//       ctx.textBaseline = 'middle';
//       ctx.fillText(videoType, canvas.width / 2, canvas.height / 2);

//       // Add camera icon
//       ctx.font = '24px Arial';
//       ctx.fillText('🎥', canvas.width / 2, canvas.height / 2 - 30);

//       const thumbnailData = canvas.toDataURL('image/jpeg', 0.9);

//       setThumbnails((prev) => {
//         if (prev[idx]) return prev;
//         return { ...prev, [idx]: thumbnailData };
//       });
//     };

//     // Set up event listeners
//     video.addEventListener('loadeddata', onLoadedData);
//     video.addEventListener('loadedmetadata', onLoadedMetadata);
//     video.addEventListener('seeked', onSeeked);
//     video.addEventListener('error', onError);

//     // Start loading the video
//     video.load();

//     // Try to play (helps with some browser quirks)
//     video.play().catch(() => {
//       // Ignore play errors - we just want to load the video
//     });

//     // Set timeout to prevent hanging
//     const timeoutId = setTimeout(() => {
//       console.warn(`Thumbnail timeout for index ${index}`);

//       // Generate fallback thumbnail with type info
//       generateFallbackThumbnail(index, videoData[index]?.type || 'Video');

//       cleanup();
//     }, 10000);

//     video.timeoutId = timeoutId;
//   }, [thumbnails, videoData]);

//   // Add thumbnail to processing queue
//   const queueThumbnail = useCallback(
//     (videoPath, index) => {
//       if (!videoPath || thumbnails[index] || thumbnailsProcessedRef.current[index]) return;

//       thumbnailQueue.current.push({ videoPath, index });

//       if (!processingThumbnail.current) {
//         processNextThumbnail();
//       }
//     },
//     [thumbnails, processNextThumbnail]
//   );

//   // Memoize video data to prevent unnecessary re-renders
//   const memoizedVideoData = useMemo(() => videoData, [JSON.stringify(videoData)]);

//   // Intersection Observer setup for lazy loading
//   useEffect(() => {
//     if (!memoizedVideoData?.length) return;

//     // Don't clear queue when component re-renders to prevent blinking
//     // Only add new items to the queue

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const index = parseInt(entry.target.dataset.index, 10);
//             const videoPath = memoizedVideoData[index]?.videos;
//             // Only queue if we don't have this thumbnail already and it's not being processed
//             if (videoPath && !thumbnails[index] && !thumbnailsProcessedRef.current[index]) {
//               queueThumbnail(videoPath, index);
//             }
//           }
//         });
//       },
//       { threshold: 0.1, rootMargin: '200px' }
//     );

//     observerRef.current = observer;

//     // Observe initial items
//     document.querySelectorAll('[data-video-item]').forEach((item) => {
//       const index = parseInt(item.dataset.index, 10);
//       if (index < visibleItems) observer.observe(item);
//     });

//     return () => {
//       observer.disconnect();
//       Object.values(videoRefs.current).forEach((video) => {
//         if (video && video.timeoutId) {
//           clearTimeout(video.timeoutId);
//         }
//         if (video) {
//           video.pause();
//           video.removeAttribute('src');
//           video.load();
//           if (document.body.contains(video)) {
//             document.body.removeChild(video);
//           }
//         }
//       });
//     };
//   }, [memoizedVideoData, queueThumbnail, visibleItems, thumbnails]);

//   useEffect(() => {
//     if (!observerRef.current || !memoizedVideoData?.length) return;

//     const newItems = Array.from({ length: 5 }, (_, i) => visibleItems - 5 + i)
//       .filter((i) => i >= 0 && i < memoizedVideoData.length)
//       .map((i) => document.querySelector(`[data-video-item][data-index="${i}"]`))
//       .filter(Boolean);

//     newItems.forEach((item) => observerRef.current.observe(item));
//   }, [visibleItems, memoizedVideoData]);

//   // Load more items on scroll
//   const loadMoreItems = useCallback(() => {
//     if (loadingRef.current || visibleItems >= memoizedVideoData.length) return;

//     loadingRef.current = true;
//     setVisibleItems((prev) => {
//       const newValue = Math.min(prev + 5, memoizedVideoData.length);
//       loadingRef.current = false;
//       return newValue;
//     });
//   }, [visibleItems, memoizedVideoData.length]);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.innerHeight + window.scrollY > document.body.offsetHeight - 800) {
//         loadMoreItems();
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [loadMoreItems]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       // This cleanup only runs on complete component unmount
//       thumbnailQueue.current = [];
//       processingThumbnail.current = false;
//       thumbnailsProcessedRef.current = {};

//       // Clean up any pending video elements
//       Object.values(videoRefs.current).forEach((video) => {
//         if (video) {
//           if (video.timeoutId) clearTimeout(video.timeoutId);
//           video.src = '';
//           video.remove();
//         }
//       });
//       videoRefs.current = {};
//     };
//   }, []);

//   // Fetch data when params change
//   useEffect(() => {
//     const dateToUse = date || currentDate;
//     const deviceToUse = device?.device_name || selectedCamera?.device_name;
//     if (dateToUse && deviceToUse) fetchVideoData(dateToUse, deviceToUse);
//   }, [date, device, currentDate, selectedCamera]);

//   // const getTypeColor = (type) => {
//   //   switch (type?.toLowerCase()) {
//   //     case 'alert':
//   //       return 'bg-red-500';
//   //     case 'motion':
//   //       return 'bg-orange-500';
//   //     case 'person':
//   //       return 'bg-purple-500';
//   //     case 'vehicle':
//   //       return 'bg-blue-500';
//   //     case 'dock':
//   //       return 'bg-green-500';
//   //     default:
//   //       return 'bg-gray-500';
//   //   }
//   // };

//   // const formatTimestamp = (timestamp) => {
//   //   if (!timestamp) return '';
//   //   try {
//   //     const date = new Date(timestamp);
//   //     return date.toLocaleTimeString();
//   //   } catch (e) {
//   //     const matches = timestamp.match(/(\d{2}):(\d{2}):(\d{2})/);
//   //     if (matches) {
//   //       return matches[0];
//   //     }
//   //     return timestamp;
//   //   }
//   // };

//   if (loading) {
//     return (
//       <Box className="flex justify-center items-center h-64">
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error)
//     return (
//       <Alert severity="error" className="my-4">
//         {error}
//       </Alert>
//     );

//   if (!memoizedVideoData?.length)
//     return (
//       <Alert severity="info" className="my-4">
//         No evidence found for this date and device.
//       </Alert>
//     );

//   return (
//     <div ref={containerRef}>
//       {/* <Divider className="my-4" /> */}
//       <div className="mb-4">
//         {/* <Typography variant="h6" className="mb-3">
//           All Evidence ({memoizedVideoData.length})
//         </Typography> */}

//         <div className="mb-0 flex flex-col space-y-4">
//           {memoizedVideoData.slice(0, visibleItems).map((videoGroup, index) => (
//             <div key={`video-${index}`} data-video-item data-index={index}>
//               <div
//                 className={`flex bg-white h-32 rounded-lg shadow-lg text-xs p-4 relative hover:shadow-xl transition-all ${
//                   source.endsWith(videoGroup?.videos) ? 'border-2 border-blue-500 bg-blue-50' : ''
//                 } ${!videoGroup?.videos ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
//                 onClick={() => {
//                   if (!videoGroup?.videos) return;

//                   const videoUrl = videoGroup.videos;
//                   dispatch({ type: SET_CAMERA_SOURCE, videoSource: videoUrl });
//                   setSource(videoUrl);
//                   // setSelectedVideo(videoGroup);
//                 }}
//               >
//                 {/* Left Side: Video Thumbnail */}
//                 <div className="flex w-1/3 items-center justify-center bg-gray-200 rounded-lg overflow-hidden">
//                   {thumbnails[index] ? (
//                     <img
//                       src={thumbnails[index]}
//                       alt={`${videoGroup?.type || 'Video'} Thumbnail`}
//                       className="w-full h-full object-cover"
//                       loading="lazy"
//                     />
//                   ) : (
//                     <div className="w-full h-full flex items-center justify-center text-gray-400">
//                       <VideocamIcon className="text-4xl" />
//                     </div>
//                   )}
//                 </div>

//                 {/* Right Side: Video Info */}
//                 <div className="flex flex-col flex-grow px-4">
//                   {/* <div className="flex items-center gap-2 mb-2">
//                     <h2 className="text-lg font-semibold cursor-default hover:text-blue-600 transition-colors duration-200">
//                       {videoGroup?.type?.charAt(0)?.toUpperCase() + videoGroup?.type?.slice(1) || 'Video'}
//                     </h2>
//                   </div> */}

//                   {/* <div className="flex flex-wrap gap-2 mb-2">
//                     {videoGroup.shoes === false && (
//                       <Tooltip
//                         title={
//                           <div className="p-2">
//                             <span className="text-gray-800 font-medium text-sm">
//                               Track ID {convertLong(videoGroup.track_id) || ''} was not wearing shoes
//                             </span>
//                           </div>
//                         }
//                         placement="bottom"
//                         arrow
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               bgcolor: 'white',
//                               color: 'text.primary',
//                               border: '1px solid #e5e7eb',
//                               borderRadius: '8px',
//                               boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//                               padding: '12px',
//                               maxWidth: 'none'
//                             }
//                           },
//                           arrow: {
//                             sx: {
//                               color: 'white',
//                               '&:before': {
//                                 border: '1px solid #e5e7eb'
//                               }
//                             }
//                           }
//                         }}
//                         enterTouchDelay={0}
//                         leaveTouchDelay={2000}
//                       >
//                         <div
//                           className={`text-black border border-gray-300 hover:border-amber-500 hover:text-amber-500 text-sm px-3 py-1 rounded-full font-medium cursor-pointer select-none flex items-center justify-center w-fit text-center transition-colors duration-200`}
//                         >
//                           <span>Shoes</span>
//                         </div>
//                       </Tooltip>
//                     )}

//                     {videoGroup.ppe === false && (
//                       <Tooltip
//                         title={
//                           <div className="p-2">
//                             <span className="text-gray-800 font-medium text-sm">
//                               Track ID {convertLong(videoGroup.track_id) || ''} was not wearing PPE equipment
//                             </span>
//                           </div>
//                         }
//                         placement="bottom"
//                         arrow
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               bgcolor: 'white',
//                               color: 'text.primary',
//                               border: '1px solid #e5e7eb',
//                               borderRadius: '8px',
//                               boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//                               padding: '12px',
//                               maxWidth: 'none'
//                             }
//                           },
//                           arrow: {
//                             sx: {
//                               color: 'white',
//                               '&:before': {
//                                 border: '1px solid #e5e7eb'
//                               }
//                             }
//                           }
//                         }}
//                         enterTouchDelay={0}
//                         leaveTouchDelay={2000}
//                       >
//                         <div
//                           className={`text-black border border-gray-300 hover:border-amber-500 hover:text-amber-500 text-sm px-3 py-1 rounded-full font-medium cursor-pointer select-none flex items-center justify-center w-fit text-center transition-colors duration-200`}
//                         >
//                           <span>PPE</span>
//                         </div>
//                       </Tooltip>
//                     )}

//                     {videoGroup.helmet === false && (
//                       <Tooltip
//                         title={
//                           <div className="p-2">
//                             <span className="text-gray-800 font-medium text-sm">
//                               Track ID {convertLong(videoGroup.track_id) || ''} was not wearing a helmet
//                             </span>
//                           </div>
//                         }
//                         placement="bottom"
//                         arrow
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               bgcolor: 'white',
//                               color: 'text.primary',
//                               border: '1px solid #e5e7eb',
//                               borderRadius: '8px',
//                               boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//                               padding: '12px',
//                               maxWidth: 'none'
//                             }
//                           },
//                           arrow: {
//                             sx: {
//                               color: 'white',
//                               '&:before': {
//                                 border: '1px solid #e5e7eb'
//                               }
//                             }
//                           }
//                         }}
//                         enterTouchDelay={0}
//                         leaveTouchDelay={2000}
//                       >
//                         <div
//                           className={`text-black border border-gray-300 hover:border-amber-500 hover:text-amber-500 text-sm px-3 py-1 rounded-full font-medium cursor-pointer select-none flex items-center justify-center w-fit text-center transition-colors duration-200`}
//                         >
//                           <span>Helmet</span>
//                         </div>
//                       </Tooltip>
//                     )}

//                     {videoGroup?.device && videoGroup.device === 'D014' && (
//                       <Tooltip
//                         title={
//                           <div className="p-2">
//                             <span className="text-gray-800 font-medium text-sm">
//                               Exit camera view - capturing individuals leaving the area
//                             </span>
//                           </div>
//                         }
//                         placement="bottom"
//                         arrow
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               bgcolor: 'white',
//                               color: 'text.primary',
//                               border: '1px solid #e5e7eb',
//                               borderRadius: '8px',
//                               boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//                               padding: '12px',
//                               maxWidth: 'none'
//                             }
//                           },
//                           arrow: {
//                             sx: {
//                               color: 'white',
//                               '&:before': {
//                                 border: '1px solid #e5e7eb'
//                               }
//                             }
//                           }
//                         }}
//                         enterTouchDelay={0}
//                         leaveTouchDelay={2000}
//                       >
//                         <div
//                           className={`text-black border border-gray-300 hover:border-blue-500 hover:text-blue-500 text-sm px-3 py-1 rounded-full font-medium cursor-pointer select-none flex items-center justify-center w-fit text-center transition-colors duration-200`}
//                         >
//                           <span>Exit</span>
//                         </div>
//                       </Tooltip>
//                     )}

//                     {videoGroup?.device && videoGroup.device === 'D012' && (
//                       <Tooltip
//                         title={
//                           <div className="p-2">
//                             <span className="text-gray-800 font-medium text-sm">
//                               Entry camera view - capturing individuals entering the area
//                             </span>
//                           </div>
//                         }
//                         placement="bottom"
//                         arrow
//                         componentsProps={{
//                           tooltip: {
//                             sx: {
//                               bgcolor: 'white',
//                               color: 'text.primary',
//                               border: '1px solid #e5e7eb',
//                               borderRadius: '8px',
//                               boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//                               padding: '12px',
//                               maxWidth: 'none'
//                             }
//                           },
//                           arrow: {
//                             sx: {
//                               color: 'white',
//                               '&:before': {
//                                 border: '1px solid #e5e7eb'
//                               }
//                             }
//                           }
//                         }}
//                         enterTouchDelay={0}
//                         leaveTouchDelay={2000}
//                       >
//                         <div
//                           className={`text-black border border-gray-300 hover:border-blue-500 hover:text-blue-500 text-sm px-3 py-1 rounded-full font-medium cursor-pointer select-none flex items-center justify-center w-fit text-center transition-colors duration-200`}
//                         >
//                           <span>Entry</span>
//                         </div>
//                       </Tooltip>
//                     )}
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {visibleItems < memoizedVideoData.length && (
//           <div className="flex justify-center mt-4">
//             <button onClick={loadMoreItems} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
//               Load More
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EvidenceList;







import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, CircularProgress, Divider, Alert, Box, Button, ButtonGroup } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';
import { SET_CAMERA_SOURCE } from 'store/actions';

const EvidenceList = ({ date, device }) => {
  const dispatch = useDispatch();
  const [thumbnails, setThumbnails] = useState({});
  const [filteredVideoData, setFilteredVideoData] = useState([]);
  const [allVideoData, setAllVideoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [source, setSource] = useState('');
  const [visibleItems, setVisibleItems] = useState(5);
  const [videoType, setVideoType] = useState('dock');

  const containerRef = useRef(null);
  const observerRef = useRef(null);
  const processingThumbnails = useRef(new Set());
  const generatedThumbnails = useRef(new Set());
  const videoRefs = useRef({});
  const loadingRef = useRef(false);
  const currentDate = useSelector((state) => state.customization.currentDate);
  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  
  // Get source_id and handle potential parsing errors
  const getSourceId = () => {
    try {
      const stored = localStorage.getItem('source');
      console.log('Raw localStorage source:', stored);
      const parsed = JSON.parse(stored);
      console.log('Parsed source_id:', parsed);
      return parsed;
    } catch (e) {
      console.error('Error parsing source from localStorage:', e);
      return null;
    }
  };
  
  const source_id = getSourceId();

  // Check if current device is D03
  const isD03Device = () => {
    const currentDevice = device?.device_name || selectedCamera?.device_name;
    return currentDevice === 'D03';
  };

  // Filter videos by date
  const filterVideosByDate = useCallback((videos, selectedDate) => {
    if (!videos || !videos.length || !selectedDate) return [];
    const startOfDay = new Date(selectedDate);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(selectedDate);
    endOfDay.setHours(23, 59, 59, 999);
    return videos.filter((video) => {
      const videoDate = new Date(video.start_time);
      return videoDate >= startOfDay && videoDate <= endOfDay;
    });
  }, []);

  // Updated filter function based on API response
  const filterVideosByType = useCallback((videos, type) => {
    if (!videos || !videos.length) return [];

    // Only filter by type if it's D03 device, otherwise return all videos
    if (isD03Device()) {
      if (type === 'dock') {
        return videos.filter((video) => video.type === 'dock');
      } else if (type === 'safety') {
        return videos.filter((video) => video.type === 'safety');
      }
    }
    return videos;
  }, [device, selectedCamera]);

  // Fetch video data
  const fetchVideoData = async (date, device) => {
    try {
      setLoading(true);
      setError(null);
      setThumbnails({});
      processingThumbnails.current.clear();
      generatedThumbnails.current.clear();

      // Handle rodent camera specially - don't call API, just show rodent videos
      console.log('Checking rodent condition:', device, source_id);
      if (device === 'Rodent' && source_id === 'dombivli') {
        console.log('Rodent camera detected - loading local videos');
        const rodentVideos = [
          {
            start_time: "2025-07-20T05:26:49.847Z",
            track_id: "dombivli_rodent_00014",
            end_time: "2025-07-20T05:26:52.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00014.mp4?sp=r&st=2025-09-15T08:37:27Z&se=2026-07-01T16:52:27Z&spr=https&sv=2024-11-04&sr=b&sig=sBwYtDjDu7IBeDr1KZecNHE%2FMSUIvPx%2F3hZ1wfvAyC4%3D",
            thumbnail: null,
            type: "Rodent",
            gender: "Male",
            age: 28
          },
          {
            start_time: "2025-07-20T05:27:10.847Z",
            track_id: "dombivli_rodent_00032", 
            end_time: "2025-07-20T05:27:15.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00032.mp4?sp=r&st=2025-09-15T08:38:35Z&se=2026-05-01T16:53:35Z&spr=https&sv=2024-11-04&sr=b&sig=syLWRn8vX0EuY8373PxnklNaruONPhZ%2F7yBBf%2Be6GxA%3D",
            thumbnail: null,
            type: "Rodent",
            gender: "Female",
            age: 34
          },
          {
            start_time: "2025-07-20T05:27:30.847Z",
            track_id: "dombivli_rodent_00033", 
            end_time: "2025-07-20T05:27:35.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00033.mp4?sp=r&st=2025-09-15T08:39:04Z&se=2026-05-01T16:54:04Z&spr=https&sv=2024-11-04&sr=b&sig=bucpDsoVqNmSdOk19vy5dwLu4G%2Bd%2FDNV6tMWlWehRws%3D",
            thumbnail: null,
            type: "Rodent",
            gender: "Male",
            age: 42
          },
          {
            start_time: "2025-07-20T05:27:30.847Z",
            track_id: "dombivli_rodent_00033", 
            end_time: "2025-07-20T05:27:35.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00044.mp4?sp=r&st=2025-09-15T08:40:09Z&se=2026-05-01T16:55:09Z&spr=https&sv=2024-11-04&sr=b&sig=BjGdeQwuYDW6OJaWdZ%2FYmT4Ciibb%2F36B6BShcmz1ra0%3D",
            thumbnail: null,
            type: "Rodent",
            gender: "Female",
            age: 25
          }
        ];

        setAllVideoData(rodentVideos);
        setFilteredVideoData(rodentVideos);

        // Set first rodent video as default
        if (rodentVideos[0]) {
          const url = rodentVideos[0].videos;
          setSource(url);
          dispatch({ type: SET_CAMERA_SOURCE, videoSource: url });
        }

        setLoading(false);
        return;
      }

      // Regular API call for other cameras
      const response = await fetch('https://db.neophyte.live/sentinel-api/api/sentinel/evidenceList', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, source: source_id })
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      let processedData = data;

      // Add additional camera data when source is 'dombivli' (for other cameras)
      if (source_id === 'dombivli') {
        const additionalCameraData = [
          {
            start_time: "2025-07-20T05:26:49.847Z",
            track_id: "dombivli_rodent_00014",
            end_time: "2025-07-20T05:26:52.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00014.mp4?sp=r&st=2025-09-15T08:37:27Z&se=2026-07-01T16:52:27Z&spr=https&sv=2024-11-04&sr=b&sig=sBwYtDjDu7IBeDr1KZecNHE%2FMSUIvPx%2F3hZ1wfvAyC4%3D",
            thumbnail: null,
            type: "Rodent",
           
          },
          {
            start_time: "2025-07-20T05:27:10.847Z",
            track_id: "dombivli_rodent_00032", 
            end_time: "2025-07-20T05:27:15.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00032.mp4?sp=r&st=2025-09-15T08:38:35Z&se=2026-05-01T16:53:35Z&spr=https&sv=2024-11-04&sr=b&sig=syLWRn8vX0EuY8373PxnklNaruONPhZ%2F7yBBf%2Be6GxA%3D",
            thumbnail: null,
            type: "Rodent",
            
          },
          {
            start_time: "2025-07-20T05:27:30.847Z",
            track_id: "dombivli_rodent_00033", 
            end_time: "2025-07-20T05:27:35.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00033.mp4?sp=r&st=2025-09-15T08:39:04Z&se=2026-05-01T16:54:04Z&spr=https&sv=2024-11-04&sr=b&sig=bucpDsoVqNmSdOk19vy5dwLu4G%2Bd%2FDNV6tMWlWehRws%3D",
            thumbnail: null,
            type: "Rodent",
            
          },
          {
            start_time: "2025-07-20T05:27:30.847Z",
            track_id: "dombivli_rodent_00033", 
            end_time: "2025-07-20T05:27:35.647Z",
            videos: "https://sentinelv1.blob.core.windows.net/video-backup/rodent/23-30-02_00044.mp4?sp=r&st=2025-09-15T08:40:09Z&se=2026-05-01T16:55:09Z&spr=https&sv=2024-11-04&sr=b&sig=BjGdeQwuYDW6OJaWdZ%2FYmT4Ciibb%2F36B6BShcmz1ra0%3D",
            thumbnail: null,
            type: "Rodent",
            
          }
        ];
        
        // Use spread operator to combine original data with additional camera data
        processedData = [...data, ...additionalCameraData];
      }

      const filteredByDate = filterVideosByDate(processedData, date || currentDate);

      setAllVideoData(filteredByDate);
      
      // Only apply type filtering for D03 device
      const filteredByType = isD03Device() ? filterVideosByType(filteredByDate, videoType) : filteredByDate;
      setFilteredVideoData(filteredByType);

      if (filteredByType?.[0]) {
        const firstItem = filteredByType[0];
        // Use thumbnail if available, otherwise fall back to videos
        const url = firstItem.thumbnail || firstItem.videos;
        if (url) {
          setSource(url);
          dispatch({ type: SET_CAMERA_SOURCE, videoSource: url });
        }
      }
    } catch (error) {
      console.error('Error fetching video data:', error);
      setError(error.message || 'Failed to fetch evidence data');
    } finally {
      setLoading(false);
    }
  };

  // Handle video type change
  const handleVideoTypeChange = (type) => {
    setVideoType(type);
    setVisibleItems(5);
    const filtered = filterVideosByType(allVideoData, type);
    setFilteredVideoData(filtered);

    if (filtered?.[0]) {
      const firstItem = filtered[0];
      const url = firstItem.thumbnail || firstItem.videos;
      if (url) {
        setSource(url);
        dispatch({ type: SET_CAMERA_SOURCE, videoSource: url });
      }
    } else {
      setSource('');
    }
  };

  // Use API-provided thumbnails instead of generating them
  const loadThumbnail = useCallback(
    (item, index) => {
      if (generatedThumbnails.current.has(index) || processingThumbnails.current.has(index) || thumbnails[index]) {
        return;
      }

      processingThumbnails.current.add(index);
      generatedThumbnails.current.add(index);

      // Use the thumbnail from API response
      if (item.thumbnail) {
        setThumbnails((prev) => ({ ...prev, [index]: item.thumbnail }));
        processingThumbnails.current.delete(index);
      } else {
        // Fallback: generate thumbnail from video if no thumbnail provided
        const video = document.createElement('video');
        videoRefs.current[index] = video;
        video.src = `${item.videos}`;
        video.crossOrigin = 'anonymous';
        video.preload = 'metadata';
        video.muted = true;

        const cleanup = () => {
          processingThumbnails.current.delete(index);
          if (video.timeoutId) clearTimeout(video.timeoutId);
          video.removeEventListener('loadedmetadata', onLoadedMetadata);
          video.removeEventListener('seeked', onSeeked);
          video.removeEventListener('error', onError);
          video.src = '';
          delete videoRefs.current[index];
        };

        const onLoadedMetadata = () => {
          video.currentTime = Math.min(2, video.duration * 0.1);
        };

        const onSeeked = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = 240;
            canvas.height = 135;
            const ctx = canvas.getContext('2d');

            ctx.fillStyle = '#000';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.7);

            setThumbnails((prev) => ({ ...prev, [index]: thumbnailUrl }));
          } catch (e) {
            console.error(`Thumbnail generation error for index ${index}:`, e);
            setThumbnails((prev) => ({ ...prev, [index]: null }));
          } finally {
            cleanup();
          }
        };

        const onError = (e) => {
          console.error(`Video load error for index ${index}:`, e);
          setThumbnails((prev) => ({ ...prev, [index]: null }));
          cleanup();
        };

        video.addEventListener('loadedmetadata', onLoadedMetadata);
        video.addEventListener('seeked', onSeeked);
        video.addEventListener('error', onError);

        video.timeoutId = setTimeout(() => {
          console.warn(`Thumbnail timeout for index ${index}`);
          setThumbnails((prev) => ({ ...prev, [index]: null }));
          cleanup();
        }, 15000);
      }
    },
    [thumbnails]
  );

  // Setup intersection observer for lazy loading thumbnails
  useEffect(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    if (!filteredVideoData?.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index, 10);
            const item = filteredVideoData[index];

            if (item && !generatedThumbnails.current.has(index) && !processingThumbnails.current.has(index) && !thumbnails[index]) {
              loadThumbnail(item, index);
            }
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '200px'
      }
    );

    observerRef.current = observer;

    setTimeout(() => {
      const items = document.querySelectorAll('[data-video-item]');
      items.forEach((item) => {
        if (observerRef.current) {
          observerRef.current.observe(item);
        }
      });
    }, 100);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [filteredVideoData, loadThumbnail, visibleItems]);

  // Load more items on scroll
  const loadMoreItems = useCallback(() => {
    if (loadingRef.current || visibleItems >= filteredVideoData.length) return;

    loadingRef.current = true;
    setVisibleItems((prev) => {
      const newValue = Math.min(prev + 5, filteredVideoData.length);
      setTimeout(() => {
        loadingRef.current = false;
      }, 100);
      return newValue;
    });
  }, [visibleItems, filteredVideoData.length]);

  // Scroll event listener with throttling
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (window.innerHeight + window.scrollY > document.body.offsetHeight - 800) {
            loadMoreItems();
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loadMoreItems]);

  // Cleanup on unmount or data change
  useEffect(() => {
    return () => {
      processingThumbnails.current.clear();
      generatedThumbnails.current.clear();

      Object.values(videoRefs.current).forEach((video) => {
        if (video) {
          if (video.timeoutId) clearTimeout(video.timeoutId);
          video.src = '';
        }
      });
      videoRefs.current = {};

      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, []);

  // Fetch data when params change
  useEffect(() => {
    const dateToUse = date || currentDate;
    const deviceToUse = device?.device_name || selectedCamera?.device_name;
    console.log('Fetching data for device:', deviceToUse, 'Date:', dateToUse);
    if (dateToUse && deviceToUse) {
      fetchVideoData(dateToUse, deviceToUse);
    }
  }, [date, device, currentDate, selectedCamera]);

  // const getTypeColor = (type) =>
  //   ({
  //     alert: 'bg-red-500',
  //     motion: 'bg-orange-500',
  //     person: 'bg-purple-500',
  //     vehicle: 'bg-blue-500',
  //     dock: 'bg-blue-500',
  //     unloaded: 'bg-blue-500',
  //     safety: 'bg-gray-500'
  //   }[type?.toLowerCase()] || 'bg-gray-500');

  const getSafetyItemColor = (item) =>
    ({
      shoes: 'bg-red-500',
      ppe: 'bg-red-500',
      helmet: 'bg-red-500',
      entry: 'bg-blue-500',
      exit: 'bg-blue-500'
    }[item?.toLowerCase()] || 'bg-gray-500');

  const formatDate = (dateStr) =>
    dateStr
      ? new Date(dateStr).toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })
      : '';

  // Render states
  if (loading) {
    return (
      <Box className="flex justify-center items-center h-64">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" className="my-4">
        {error}
      </Alert>
    );
  }

  return (
    <div ref={containerRef}>
      <Divider className="my-4" />
      <div className="mb-4">
        <div className="flex justify-between items-center mb-3">
          <Typography variant="h6">
            All Evidence ({filteredVideoData.length})
            {isD03Device() && ` - ${videoType.charAt(0).toUpperCase() + videoType.slice(1)}`}
          </Typography>
          
          {/* Conditionally render toggle buttons only for D03 device */}
          {isD03Device() && (
            <ButtonGroup variant="contained" size="small">
              <Button onClick={() => handleVideoTypeChange('dock')} color={videoType === 'dock' ? 'primary' : 'inherit'}>
                Dock
              </Button>
              {/* <Button onClick={() => handleVideoTypeChange('dock')} color={videoType === 'unloaded' ? 'primary' : 'inherit'}>
                Unloaded
              </Button> */}
              <Button onClick={() => handleVideoTypeChange('safety')} color={videoType === 'safety' ? 'primary' : 'inherit'}>
                Safety
              </Button>
            </ButtonGroup>
          )}
        </div>

        {!filteredVideoData?.length ? (
          <Alert severity="info" className="my-4">
            No {isD03Device() ? videoType : ''} evidence found for this date and device.
          </Alert>
        ) : (
          <>
            <div className="mb-0 border flex flex-col space-y-4">
              {filteredVideoData.slice(0, visibleItems).map((videoGroup, index) => (
                <div key={`video-${index}-${videoGroup.start_time}`} data-video-item data-index={index}>
                  <div
                    className={`flex border bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer overflow-hidden ${
                      source.endsWith(videoGroup?.videos) ? 'ring-2 ring-blue-500' : 'hover:bg-gray-50'
                    }`}
                    onClick={() => {
                      // Use thumbnail if available, otherwise fall back to videos
                      const url = videoGroup.thumbnail || videoGroup.videos;
                      if (url) {
                        setSource(url);
                        dispatch({ type: SET_CAMERA_SOURCE, videoSource: url });
                      }
                    }}
                  >
                    <div className="w-1/2">
                      <div className="relative w-full h-full aspect-video object-cover bg-gray-200 overflow-hidden">
                        {thumbnails[index] ? (
                          <img
                            src={thumbnails[index]}
                            alt={`${videoGroup?.type || 'Video'} Thumbnail`}
                            className="w-full h-full object-cover"
                            loading="lazy"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-gray-400">
                            {processingThumbnails.current.has(index) ? <CircularProgress size={24} /> : <VideocamIcon />}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="w-1/2 p-3 flex flex-col justify-center bg-gradient-to-br from-gray-50 to-white">
                     

                      {/* Gender & Age Information - Only for non-Rodent types */}
                      {videoGroup?.type !== 'Rodent' && (
                        <div className="space-y-3 mb-4">
                          {/* Gender Display */}
                          <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-2">
                              <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                              <span className="text-gray-600 text-sm font-medium">Gender:</span>
                            </div>
                            <div className={`px-3 py-1 rounded-full text-sm font-semibold shadow-sm ${
                              (videoGroup?.gender || 'Unknown').toLowerCase() === 'male' 
                                ? 'bg-blue-100 text-blue-800 border border-blue-200' 
                                : (videoGroup?.gender || 'Unknown').toLowerCase() === 'female'
                                ? 'bg-pink-100 text-pink-800 border border-pink-200'
                                : 'bg-gray-100 text-gray-800 border border-gray-200'
                            }`}>
                              {videoGroup?.gender ? videoGroup.gender.charAt(0).toUpperCase() + videoGroup.gender.slice(1).toLowerCase() : 'Unknown'}
                            </div>
                          </div>

                          {/* Age Display */}
                          <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-2">
                              <div className="w-2 h-2 rounded-full bg-green-500"></div>
                              <span className="text-gray-600 text-sm font-medium">Age:</span>
                            </div>
                            <div className="px-3 py-1 rounded-full text-sm font-semibold bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 border border-green-200 shadow-sm">
                              {videoGroup?.age ? (videoGroup.age.charAt(0).toUpperCase() + videoGroup.age.slice(1).toLowerCase()) : 'Unknown'}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Safety Information for safety type */}
                      {videoGroup.type === 'safety' && (
                        <div className="flex flex-wrap gap-2 mb-3">
                          {videoGroup.ppe === true && (
                            <div className={`${getSafetyItemColor('ppe')} text-white text-xs px-2 py-1 rounded-full w-fit font-medium shadow-sm`}>
                              <span>PPE ✓</span>
                            </div>
                          )}
                          {videoGroup.shoes === true && (
                            <div className={`${getSafetyItemColor('shoes')} text-white text-xs px-2 py-1 rounded-full w-fit font-medium shadow-sm`}>
                              <span>Shoes ✓</span>
                            </div>
                          )}
                          {videoGroup.helmet === true && (
                            <div className={`${getSafetyItemColor('helmet')} text-white text-xs px-2 py-1 rounded-full w-fit font-medium shadow-sm`}>
                              <span>Helmet ✓</span>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Dock Information for dock type */}
                      {videoGroup.type === 'dock' && videoGroup?.instance && (
                        <div className="flex flex-wrap gap-2 mb-3">
                          <div className={`${getSafetyItemColor('unloaded')} text-white text-xs px-2 py-1 rounded-full w-fit font-medium shadow-sm`}>
                            <span>Unloaded ✓</span>
                          </div>
                        </div>
                      )}

                      {/* Rodent Information for rodent type */}
                      {console.log('Video Group Type:', videoGroup.type, 'Device Name:', videoGroup.device_name)}
                      {(videoGroup.type === 'rodent' || videoGroup.device_name === 'Rodent' || videoGroup.type?.toLowerCase() === 'rodent') && (
                        <div className="space-y-3 mb-3">
                          {/* Rodent Detection */}
                          <div className="flex flex-wrap gap-2">
                            <div className="bg-red-500 text-white text-xs px-2 py-1 rounded-full w-fit font-medium shadow-sm">
                              <span>Rodent</span>
                            </div>
                          </div>
                          
                          {/* Start Time */}
                          <div className="flex items-center space-x-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-red-400"></div>
                            <span className="text-gray-500 text-xs">Start:</span>
                            <span className="text-gray-700 font-medium text-xs">{formatDate(videoGroup.start_time)}</span>
                          </div>
                          
                          {/* End Time */}
                          <div className="flex items-center space-x-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-red-400"></div>
                            <span className="text-gray-500 text-xs">End:</span>
                            <span className="text-gray-700 font-medium text-xs">{formatDate(videoGroup.end_time)}</span>
                          </div>
                        </div>
                      )}

                      {/* Time Information - Hide for entry/exit cameras */}
                      {/* {!['entry', 'exit'].includes(videoGroup?.type?.toLowerCase()) && (
                        <div className="space-y-2 mt-auto">
                          <div className="flex items-center space-x-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
                            <span className="text-gray-500 text-xs">Start:</span>
                            <span className="text-gray-700 font-medium text-xs">{formatDate(videoGroup.start_time)}</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
                            <span className="text-gray-500 text-xs">End:</span>
                            <span className="text-gray-700 font-medium text-xs">{formatDate(videoGroup.end_time)}</span>
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {visibleItems < filteredVideoData.length && (
              <div className="flex justify-center mt-4">
                <button
                  onClick={loadMoreItems}
                  disabled={loadingRef.current}
                  className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
                >
                  {loadingRef.current ? 'Loading...' : 'Load More'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default EvidenceList;